// apps/app/src/app/components/loop/wind/winders/base/LoopWinder.ts

import { lamportsToUiAmount, bsMath } from "@bridgesplit/utils";
import { LoanCreationParams, BaseRouteStepExpanded } from "@bridgesplit/abf-sdk";
import { DEFAULT_SLIPPAGE } from "app/components/common";

import { LoopWinder, LoopWinderCtx } from "./types";

// Base class = Collateral Winder (the default behavior)
export class BaseWinder implements LoopWinder {
    name = "BaseWinder";

    getLoanCreationParams(_: LoopWinderCtx) {
        return "Default" as LoanCreationParams;
    }

    // Default collateral loop behavior
    getCollateralInputAmountForQuote(ctx: LoopWinderCtx) {
        const { form } = ctx;
        return form?.inputAmount;
    }

    getPriceOverride(ctx: LoopWinderCtx): number | undefined {
        return undefined;
    }

    getRouteOverrideParams(_: LoopWinderCtx): Partial<BaseRouteStepExpanded> | undefined {
        return undefined;
    }

    getLeveragedCollateralAmountToDeposit(ctx: LoopWinderCtx): number | undefined {
        const { loopExpanded, externalQuote, form } = ctx;
        if (!loopExpanded || !externalQuote || !form?.inputAmount || !form?.multiplier) return undefined;

        if (externalQuote.minOutputAmount === 0) {
            return form.inputAmount * (form.multiplier - (form.percentSlippageDecimals ?? DEFAULT_SLIPPAGE));
        }

        return (
            form.inputAmount + lamportsToUiAmount(externalQuote.minOutputAmount, loopExpanded.collateralToken.decimals)
        );
    }

    getCollateralInputAmount(ctx: LoopWinderCtx): number | undefined {
        const { inputAmount } = ctx;
        return inputAmount;
    }

    calculateMarketCollateralAmounts(ctx: LoopWinderCtx) {
        const { loopExpanded, externalQuote, quote } = ctx;

        const collateralInputAmount = quote?.collateralAmount;
        const collateralMinOutputAmount = externalQuote?.minOutputAmount;
        const decimals = loopExpanded?.collateralToken.decimals;

        const swappedMinOutputCollateralAmount = lamportsToUiAmount(collateralMinOutputAmount, decimals);

        const totalMinOutputCollateralAmount = bsMath.add(swappedMinOutputCollateralAmount, collateralInputAmount) ?? 0;

        return { totalMinOutputCollateralAmount, swappedMinOutputCollateralAmount };
    }
}
